// extracted by mini-css-extract-plugin
export default {"wrapper":"pz-z","button":"qz-z","alternate":"rz-z","disabled":"sz-z","paymentWarning":"tz-z","fadeIn":"uz-z"};